import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export const offsetTopBottomValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const offsetTop = control.get('offsetTop');
  const offsetBottom = control.get('offsetBottom');
  return offsetTop && offsetBottom && offsetTop.value + offsetBottom.value >= 1 ? { offsetTopBottomOutOfBounds: true } : null;
};
